import { Input, InputProps } from '../input';

import styles from './time-input.module.scss';

export const TimeInput = (props: InputProps) => (
  <div className={styles.timeInput}>
    <Input {...props} type="time" />
  </div>
);
